<script lang="ts" setup></script>
<template>
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.80607 11.237C9.80607 13.3057 8.16919 14.9827 6.14999
    14.9827C5.73288 14.9827 5.33208 14.9112 4.95865 14.7794C4.81692 14.7294
    4.74606 14.7043 4.69839 14.6948C4.6482 14.6848 4.62103 14.6821 4.56985
    14.6817C4.52124 14.6814 4.46558 14.689 4.35426 14.7042L2.3147
    14.9827L2.73104 13.1019C2.75833 12.9787 2.77198 12.917 2.77513
    12.8625C2.77842 12.8056 2.77687 12.7739 2.76803 12.7176C2.75956 12.6636
    2.73376 12.5846 2.68215 12.4266C2.56006 12.0529 2.49392 11.6529 2.49392
    11.237C2.49392 9.16836 4.1308 7.49136 6.14999 7.49136C8.16919 7.49136
    9.80607 9.16836 9.80607 11.237Z"
      fill="var(--primary)"
    />
    <path
      d="M5.1031 7.64718C5.06077 7.37438 5.03881 7.0949 5.03881 6.81033C5.03881 3.80133 7.49413 1.36206 10.5229 1.36206C13.5517 1.36206 16.007 3.80133 16.007 6.81033C16.007 7.49005 15.8817 8.1407 15.6528 8.74072C15.6053 8.86534 15.5815 8.92765 15.5707 8.9763C15.56 9.0245 15.5559 9.0584 15.5548 9.10776C15.5536 9.15758 15.5603 9.21245 15.5739 9.3222L15.848 11.5493C15.8777 11.7904 15.8925 11.911 15.8524 11.9986C15.8173 12.0754 15.7549 12.1364 15.6773 12.1697C15.5888 12.2078 15.4686 12.1902 15.2283 12.155L13.059 11.837C12.9457 11.8204 12.8891 11.8121 12.8375 11.8124C12.7865 11.8127 12.7512 11.8164 12.7012 11.8269C12.6508 11.8375 12.5863 11.8617 12.4573 11.91C11.8558 12.1353 11.2038 12.2586 10.5229 12.2586C10.2381 12.2586 9.95839 12.237 9.68529 12.1954M6.14999 14.9827C8.16919 14.9827 9.80607 13.3057 9.80607 11.237C9.80607 9.16836 8.16919 7.49136 6.14999 7.49136C4.1308 7.49136 2.49392 9.16836 2.49392 11.237C2.49392 11.6529 2.56006 12.0529 2.68215 12.4266C2.73376 12.5846 2.75956 12.6636 2.76803 12.7176C2.77687 12.7739 2.77842 12.8056 2.77513 12.8625C2.77198 12.917 2.75833 12.9787 2.73104 13.1019L2.3147 14.9827L4.35426 14.7042C4.46558 14.689 4.52124 14.6814 4.56985 14.6817C4.62103 14.6821 4.64819 14.6848 4.69839 14.6948C4.74606 14.7043 4.81692 14.7294 4.95865 14.7794C5.33208 14.9112 5.73288 14.9827 6.14999 14.9827Z"
      stroke="var(--primary)"
      stroke-width="1.36207"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
